module.exports = "/_next/static/media/44f2aa638156be906db84e69089fb2ac.svg";